import { Button } from '@/components/common/Button';
import CheckboxComponent from '@/components/common/CheckBox';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '@/components/common/DropdownMenu';
import { ItemStatus } from '@/types/item';
import { t } from 'i18next';
import { CheckIcon, ChevronDown, X } from 'lucide-react';

interface DialogFilterStatusProps {
    setShowModal: (isSelect) => void,
    listActivityFilter: ItemStatus[],
    listStatusFilter: ItemStatus[],
    onSubmit: () => void,
    onSelect: (type, id) => void
}
const DialogFilterStatus = ({ setShowModal, listActivityFilter = [], listStatusFilter = [], onSubmit = () => {}, onSelect }: DialogFilterStatusProps) => {
    return (
        <div className='w-full bg-white absolute left-0 bottom-0 p-4 rounded-t-[10px]'>
            <div className='flex justify-between items-center border-b-[1px] border-b-borderGray pb-4'>
                <p className='text-[17px] font-semibold text-gray'>フィルター</p>
                <button onClick={() => setShowModal(false)} className='w-6 h-6 flex justify-center items-center'>
                    <X className='h-4 w-4 font-bold' />
                </button>
            </div>
            <div className='pt-4 pb-6'>
                <DropdownMenu>
                    <DropdownMenuTrigger className='flex items-center gap-1'>
                        <div className='flex w-[calc(100vw-32px)] justify-between content-center border-[1px] border-bgMenubar px-3 py-4 rounded-[10px]'>
                            <p className='text-colorTextUpload text-[15px]'>{ listStatusFilter.find(e => e.isSelected === true)?.id === -1 ? t('text.status') : listStatusFilter.find(e => e.isSelected === true)?.title}</p>
                            <ChevronDown size={24} className='w-6 h-6 text-colorTextUpload' />
                        </div>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent className='w-56 border-bgMenubar shadow-lg' side='top' align='end' forceMount>
                        <p className='text-center w-full py-1 border-b-[1px] border-b-bgMenubar z-50'>{ t('text.status')}</p>
                        {listStatusFilter.map(e => (
                            <DropdownMenuItem
                                key={e.id}
                                className='hover:cursor-pointer'
                                onClick={() => onSelect(1, e.id)}
                            >
                                <div className='w-full flex justify-start items-center'>
                                    <div className='w-4 h-4'>
                                        {e.isSelected && <CheckIcon size={24} className='w-4 h-4' />}
                                    </div>
                                    <p className='ml-4'>{e.title}</p>
                                </div>
                            </DropdownMenuItem>
                        ))}
                    </DropdownMenuContent>
                </DropdownMenu>
                <DropdownMenu>
                    <DropdownMenuTrigger className='flex items-center gap-1'>
                        <div className='flex w-[calc(100vw-32px)] justify-between content-center border-[1px] border-bgMenubar px-3 py-4 rounded-[10px] mt-4'>
                            <p className='text-colorTextUpload text-[15px]'>{ listActivityFilter.find(e => e.isSelected === true)?.id === -1 ? t('text.activity') : listActivityFilter.find(e => e.isSelected === true)?.title}</p>
                            <ChevronDown size={24} className='w-6 h-6 text-colorTextUpload' />
                        </div>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent className='w-56 border-bgMenubar shadow-lg' side='top' align='end' forceMount>
                        <p className='text-center w-full py-1 border-b-[1px] border-b-bgMenubar z-50'>{ t('text.activity')}</p>
                        {listActivityFilter.map(e => (
                            <DropdownMenuItem
                                key={e.id}
                                className='hover:cursor-pointer'
                                onClick={() => onSelect(2, e.id)}
                            >
                                <div className='w-full flex justify-start items-center'>
                                    <div className='w-4 h-4'>
                                        {e.isSelected && <CheckIcon size={24} className='w-4 h-4' />}
                                    </div>
                                    <p className='ml-4'>{e.title}</p>
                                </div>
                            </DropdownMenuItem>
                        ))}

                    </DropdownMenuContent>
                </DropdownMenu>
            </div>
            <Button onClick={onSubmit} className='w-full mb-4' variant='main'>
                検索
            </Button>
        </div>
    );
};

interface DialogFilterDropItemProps {
    setShowModal: (isSelect) => void,
    listFilter: ItemStatus[],
    onSubmit: () => void,
    onSelect: (id, value) => void
}

const DialogFilterDropItem = ({ setShowModal, listFilter = [], onSubmit = () => {}, onSelect }: DialogFilterDropItemProps) => {
    return (
        <div className='w-full bg-white absolute left-0 bottom-0 p-4 rounded-t-[10px]'>
            <div className='flex justify-between items-center border-b-[1px] border-b-borderGray pb-4'>
                <p className='text-[17px] font-semibold text-gray'>フィルター</p>
                <button onClick={() => setShowModal(false)} className='w-6 h-6 flex justify-center items-center'>
                    <X className='h-4 w-4 font-bold' />
                </button>
            </div>
            <div className=' pb-6'>
                {listFilter.map(e => (
                    <div key={e.id} className='flex justify-start items-center'>
                        <CheckboxComponent className='mt-4' label={e.title} checked={e.isSelected} onCheckedChange={value => onSelect(e.id, value)} />
                    </div>
                ))}
            </div>
            <Button onClick={onSubmit} className='w-full mb-4' variant='main'>
                検索
            </Button>
        </div>
    );
};

const contentDialod = { DialogFilterStatus, DialogFilterDropItem };

export default contentDialod;
